import { Object3D, ArrowHelper, Vector3 } from 'three';


export class ThreeAxisHelper extends Object3D {
    constructor(size: number = 6) {
        super();
        this.add(new ArrowHelper(
            new Vector3(1, 0, 0),
            new Vector3(0, 0, 0),
            size,
            0xFF0000
        ));
        this.add(new ArrowHelper(
            new Vector3(0, 1, 0),
            new Vector3(0, 0, 0),
            size,
            0x00FF00
        ));
        this.add(new ArrowHelper(
            new Vector3(0, 0, 1),
            new Vector3(0, 0, 0),
            size,
            0x0000FF
        ));
    }
}
